import NoData from '@gp/components/NoData';
import React, { useMemo } from 'react';
import { Button, Col } from 'tea-component';
import SimilarItem from './components/SimilarItem';
import './index.scss';

export default function SimilarList(props: any) {
  const { similarData: similarResData, getAdd, allCountryFlag, userIsAbleEdit } = props;
  const similarData = useMemo(() => similarResData?.list, [similarResData]);

  return (
    <>
      {!similarData?.length ? (
        <NoData
          className="dbg-project-detail-visual-showcase-nodata"
          text={
            userIsAbleEdit ? (
              <>
                Please click the Edit button on the right or directly{' '}
                <Button
                  type="link"
                  onClick={() => {
                    getAdd();
                  }}
                >
                  add Similar Games.
                </Button>
              </>
            ) : (
              <>No Data</>
            )
          }
          height={160}
        />
      ) : (
        <div className="tea-row tea-grid dbg-project-detail-similar-datas-grid">
          {similarData?.map((item: any, index) => {
            const gameInfo = similarData[index];
            return (
              <Col key={index} span={6}>
                <SimilarItem allCountryFlag={allCountryFlag} gameInfo={gameInfo} />
              </Col>
            );
          })}
        </div>
      )}
    </>
  );
}
